import React from 'react';
import { Query } from '@apollo/client/react/components';

import { BookkeepersQuery } from './queries';

type BkNameContainerProps = {
  id: string;
};

const BkNameContainer = ({ id }: BkNameContainerProps) => (
  <Query query={BookkeepersQuery}>
    {({ loading, error, data: bookkeeperData }: any) => {
      if (loading) {
        return '...';
      }

      if (error) {
        return 'Unknown Person';
      }

      const data = bookkeeperData?.bookkeepers;

      const bookkeeper = data && data.find(bk => bk.id === id);

      if (bookkeeper) {
        return bookkeeper.fullName;
      }

      return 'Unknown Person';
    }}
  </Query>
);

export default BkNameContainer;
